<template>
  <footer>
    <div class="motto">
      <h3>GEEKCHIC Hàng Hiệu Sale 07</h3>
      <h3>CHUYÊN ORDER HÀNG NGUYÊN LIỆU HÃNG</h3>
    </div>
    <div class="address">
      <p>
        <span class="icon">
          <img src="@/assets/icons/location-add.png" alt="" />
        </span>
        Quận 7, TP.HCM
      </p>
    </div>
    <div class="contacts">
      <div class="mobile">
        <div class="contact">
          <h3>Phone / Zalo</h3>
          <p>0937776602</p>
        </div>
        <div class="contact">
          <h3>Fanpage</h3>
          <p @click="goToFanpage()">Hàng Hiệu Sale 07</p>
        </div>
        <div class="contact">
          <h3>Instangram</h3>
          <p>@hanghieusale95.new</p>
        </div>
      </div>
      <div class="socials">
        <div class="facebook">
          <img src="@/assets/img/facebook.svg" alt="" />
        </div>
        <div class="instangram">
          <img src="@/assets/img/instagram-svgrepo-com.svg" alt="" />
        </div>
        <div class="telegram">
          <img src="@/assets/img/telegram-svgrepo-com.svg" alt="" />
        </div>
      </div>
    </div>
    <div class="disclamer">
      <p>Phát triển bởi đội ngũ Hoàng Tín</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    goToFanpage() {
      window.open('https://www.facebook.com/hanghieusale07/', '_blank');
    },
  }
};
</script>
<style scoped lang="scss">
footer {
  max-width: 1400px;
  padding-top: 50px;
  margin: 0 auto;
  background-color: #fff;
  .motto {
    margin-bottom: 26px;
    font-weight: bold;
    color: #000;
    h2,
    h3 {
      font-size: 22px;
      line-height: 42px;
      font-weight: bold;
    }
    h2 {
      font-size: 32px;
      font-weight: bold;
    }
  }
  .address {
    margin-bottom: 50px;
    p {
      color: #000;
      font-size: 16px;
      span {
        img {
          height: 20px;
          width: auto;
          margin-right: 13px;
          transform: translateY(-4px);
        }
      }
    }
  }
  .contacts {
    display: flex;
    justify-content: space-between;
    align-items: baseline;

    .mobile {
      display: flex;
      .contact {
        color: #000;
        margin-right: 50px;
        &:last-child {
          margin-right: 0;
        }
        &:nth-child(2) {
          cursor: pointer;
        }
        h3 {
          font-size: 14px;
          margin-bottom: 10px;
        }
        p {
          font-size: 18px;
          font-weight: bold;
        }
      }
    }
    .socials {
      display: flex;
      transform: translateY(30px);
      div {
        margin-right: 30px;
        &:last-child {
          margin-right: 0;
        }
        img {
          height: 24px;
          width: auto;
        }
      }
    }
  }
  .disclamer {
    border-top: 1px solid #8f8f8f;
    padding: 20px 0;
    color: #8f8f8f;
    font-size: 16px;
  }
}
@media screen and (max-width: 1660px) and (min-width: 1279px) {
  footer {
    padding: 25px 80px 15px 80px;
  }
}
@media screen and (max-width: 1279px) and (min-width: 769px) {
  footer {
    padding: 25px 60px 15px 60px;
  }
}
@media screen and (max-width: 768px) and (min-width: 481px) {
  footer {
    padding: 25px 40px 15px 40px;
    .contacts {
      flex-direction: column;
    }
    .disclamer {
      margin-top: 50px;
    }
  }
}
@media screen and (max-width: 480px) and (min-width: 0) {
  footer {
    padding: 25px 15px 15px 15px;
    .motto {
      h2 {
        font-size: 28px;
      }
      h3 {
        font-size: 20px;
      }
    }
    .address {
      p {
        font-size: 12px;
        img {
          height: 14px !important;
        }
      }
    }
    .contacts {
      flex-direction: column;
      .mobile {
        width: 100%;
        justify-content: space-evenly;
        .contact {
          margin-right: unset;
          h3 {
            font-size: 12px !important;
            // white-space: nowrap;
          }
          p {
            font-size: 12px !important;
          }
        }
      }
      .socials {
        transform: unset !important;
        margin: 15px auto;
      }
    }
    .disclamer {
      text-align: center;
    }
  }
}
</style>
